import { createFileRoute } from "@tanstack/react-router";
import { ApprovalQueue } from "@/components/approvals/approval-queue";

export const Route = createFileRoute("/_auth/app/admin/approvals")({
  component: ApprovalsPage,
});

function ApprovalsPage() {
  return <ApprovalQueue />;
}
